/* Los revelados. Cero librería: 11 de 15 sitios de premio corren sin ninguna,
   y esto son treinta líneas. */

/* La marca se pone ANTES de pintar nada, para que el estado escondido no llegue
   tarde y se vea el salto. */
document.documentElement.classList.add('js-rev');

/* ── el titular del manifiesto, palabra por palabra ────────────────────────
   Se parte respetando el marcado: se caminan los NODOS DE TEXTO y se dejan
   intactos el <br> y el <em>. Partir por innerHTML se los come. */
/* 🔴 Y el de "¿Qué necesitas hoy?". Se quedó fuera del barrido de abajo por una
   razón tonta: ese recorre `.seccion` y busca encabezados llamados `.etiqueta`
   o `.titular`, y §3 no es `.seccion` ni su encabezado se llama así. Resultado
   medido: siete secciones con revelado y esa con CERO — el único titular grande
   del sitio que ya está ahí cuando llegas, y justo después del momento más alto
   (la flor abriendo). No era gusto, era un olvido. */
document.querySelectorAll('.manifiesto .grande, .elige .lead, .tienda .titular, .reels .titular, .library .titular, .exp .titular, .voces .conteo-tit, .pila-cab .titular, .cierre .grande').forEach(grande => {
  let n = 0;
  const parte = nodo => {
    [...nodo.childNodes].forEach(hijo => {
      if (hijo.nodeType === 3) {
        const frag = document.createDocumentFragment();
        hijo.textContent.split(/(\s+)/).forEach(t => {
          if (!t.trim()) return frag.appendChild(document.createTextNode(t));
          const s = document.createElement('span');
          s.className = 'pal'; s.style.setProperty('--i', n++);
          const i = document.createElement('i'); i.textContent = t;
          s.appendChild(i); frag.appendChild(s);
        });
        hijo.replaceWith(frag);
      } else if (hijo.nodeType === 1) parte(hijo);
    });
  };
  parte(grande);
  /* 🔴 Se guarda el TOTAL y se marca el contenedor. Dos arreglos en uno:
     · El escalonado deja de ser un paso fijo por palabra y pasa a ser un
       PRESUPUESTO repartido entre las que haya. Con 55 ms fijos, el titular de
       §3 (15 palabras) tardaba 1670 ms contra 1175 del manifiesto (6): un
       titular más largo salía automáticamente más lento, que no es una
       decisión, es una consecuencia.
     · Y se observa el BLOQUE, no palabra por palabra. Observando cada una, las
       del último renglón ni empezaban hasta entrar a pantalla y encima
       esperaban su retraso: los tiempos se sumaban. Ahora arrancan todas
       juntas y el retraso hace la ola, que es lo que se quería. */
  grande.style.setProperty('--n', Math.max(1, n - 1));
  grande.setAttribute('data-pals', '');
});

/* La píldora "¿Qué necesitas hoy?" llega ANTES que el titular: es la pregunta,
   y una pregunta que aparece después de su respuesta no es una pregunta. */
/* 🔴 La píldora de §3 YA NO lleva `data-rev`. Su llegada la manda el recorrido
   del scroll (`--llega`), y dejarle además el atributo la mataba: `[data-rev]`
   pone `opacity:0` con la MISMA especificidad que la regla del scrub y vive en
   una hoja posterior, así que ganaba — y como ya nadie le añade `.ver`, se
   quedaba invisible para siempre. Dos dueños para un gesto es un gesto roto. */

/* ── el observador ─────────────────────────────────────────────────────────
   Cada cosa se revela UNA vez, cuando entra un 18% en cuadro, y se queda.
   ⚠️ Aquí vivió una histéresis de dos umbrales para poder re-animar al subir
   (lo había pedido paco). Se retiró el 30-ago con la medición delante: el
   rearme apagaba enlaces. El porqué, en `mira()`. */
function mira(entradas, obs) {
  entradas.forEach(e => {
    /* 🔴 EL REVELADO NO SE DESHACE. Aquí había un `else if (!e.isIntersecting)
       remove('ver')` que rearmaba la entrada al salir del cuadro, para que al
       volver a bajar se re-animara. Medido lo que hacía de verdad: subiendo por
       §camino las cinco tarjetas se quedaban en **0.90 · 0.79 · 0.81 · 0.60 y
       0** de opacidad — apagándose a media transición. Y esas tarjetas SON
       enlaces: subir por la página dejaba media sección en enlaces medio
       borrados. Un adorno que se repite no vale un control que se apaga.
       `disconnect()` en cuanto entra: además deja de costar trabajo al scroll. */
    if (e.intersectionRatio >= .18) {
      e.target.classList.add('ver');
      obs.unobserve(e.target);
    }
  });
}
/* 🔴 EN CELULAR EL BLOQUE SE ARMA ANTES DE ASOMAR.
   Con `-8%` por abajo MÁS un 18% del bloque a la vista, en una pantalla de 844
   px un bloque alto pide media pantalla de scroll entre que aparece y que
   empieza a moverse — y encima tarda 850 ms en llegar. Bajando con el pulgar
   eso se ve literalmente como una página que se monta sola delante de ti. Es
   justo lo que paco reportó: «vas bajando y ves cómo se arma».
   El margen positivo ESTIRA la ventana hacia abajo, así que el bloque arranca
   fuera de cuadro y llega ya armado. La histéresis no se toca: el rearme sigue
   pidiendo que haya salido POR COMPLETO, así que no hay parpadeo.
   En escritorio se queda como estaba: ahí la pantalla es alta, el gesto es lento
   y el `-8%` da el tiempo justo. */
const enDedo = matchMedia('(pointer: coarse)').matches;
const ojo = new IntersectionObserver(mira,
  { threshold: [0, .18], rootMargin: enDedo ? '0px 0px 25% 0px' : '0px 0px -8% 0px' });

/* 🔴 Un observador con root = ventana NO VE lo que está fuera de un carrusel
   horizontal: en celular la fila de Reels arrastra, y los reels 3 y 4 se
   quedaban en opacity 0 PARA SIEMPRE — ni arrastrando aparecían.
   Cuando el elemento vive dentro de algo que hace scroll propio, ese contenedor
   tiene que ser el `root`. Los observadores por contenedor se guardan para no
   crear uno por tarjeta. */
const porCaja = new Map();
function vigila(el) {
  const caja = el.parentElement;
  const corre = caja && /auto|scroll/.test(getComputedStyle(caja).overflowX);
  if (!corre) return ojo.observe(el);
  if (!porCaja.has(caja)) porCaja.set(caja,
    new IntersectionObserver(mira, { root: caja, threshold: [0, .18] }));
  porCaja.get(caja).observe(el);
}

/* 🔴 Los titulares se ANTICIPAN. El observador normal recorta un 8% por abajo y
   además pide un 18% del bloque a la vista; para un titular de 398 px eso son
   383 px de scroll —casi media pantalla— entre que la marea de papel tapa y la
   primera palabra se mueve. Media pantalla de crema quieta después del momento
   más alto del sitio es exactamente el "tarda mucho en aparecer".
   Con el margen positivo la ventana se ESTIRA hacia abajo, así que el titular
   arranca antes de asomar y llega armado justo cuando lo tienes enfrente. */
const ojoAntes = new IntersectionObserver(mira,
  { threshold: [0, .18], rootMargin: '0px 0px 22% 0px' });
/* 🔴 El encabezado de §3 SE EXCLUYE de aquí: su llegada ya no la decide un
   observador propio sino la marea del valle (vida.js → `entrega()`), porque las
   dos secciones comparten la misma hoja de papel. Si además lo observara este
   barrido, se encendería antes de tiempo —que es justo lo que hacía que §3
   apareciera ya montada— y tendríamos dos dueños para el mismo gesto. */
document.querySelectorAll('[data-pals], .elige .q[data-rev]')
  .forEach(el => { if (!el.closest('.elige')) ojoAntes.observe(el); });

/* Respaldo: si no hay valle que la entregue —movimiento reducido, o un cambio
   futuro de estructura— la cabeza de §3 se enciende sola. Sin esto quedaría
   escondida para siempre, que es el peor de los fallos posibles. */
if (!document.getElementById('universo') ||
    matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('.elige .q, .elige .lead')
    .forEach(el => el.classList.add('ver'));
}

/* 🔴 Las cinco vías se tienden en cascada. Se observa el CONTENEDOR, no cada
   fila: observando una por una, las de abajo esperan a entrar en pantalla y
   encima esperan su retraso —los tiempos se suman y la cascada deja de leerse
   como cascada—. Es exactamente el mismo arreglo que ya se hizo con las palabras
   del titular.
   El índice lo pone el JS porque el retraso es del CSS: así el escalonado se
   ajusta cambiando un número en la hoja, no aquí. */
/* 🔴 Y va con el observador NORMAL, no con el anticipado. Probado y fotografiado:
   con `ojoAntes` la cascada arrancaba con el titular todavía ocupando la pantalla
   —solo se veía UNA fila— y las otras cuatro terminaban su barrido debajo del
   pliegue. Una animación que nadie ve no es una animación, es trabajo tirado.
   Con el observador normal (18% del bloque dentro, y recortando un 8% por abajo)
   arranca cuando el titular ya subió y hay varias filas en cuadro. */
/* 🔴 CADA FILA SE OBSERVA A SÍ MISMA, y llegar aquí costó tres intentos medidos:
     · contenedor + `ojoAntes` → disparaba con el titular llenando la pantalla:
       UNA fila en cuadro y las otras cuatro barriendo debajo del pliegue.
     · contenedor + `ojo` (18%) → dos filas.
     · contenedor + umbral propio al 42% → tres. Pero al medir el precio salió lo
       que lo mató: **521 px de scroll con las filas invisibles** antes de
       arrancar. O sea, para ganar una cascada bonita se estaba pagando
       exactamente el vacío de arena que paco venía señalando.
   Observando fila por fila con anticipación, cada una ya viene barriendo cuando
   asoma: el vacío es cero y el escalonado lo pone el propio scroll. En una lista
   más alta que la ventana ésa es la forma correcta; la cascada por contenedor
   sirve cuando el bloque cabe entero, que aquí no pasa.
   El retraso por `--i` se queda MUY corto (36 ms) y solo se nota en las filas que
   entran juntas: con un retraso largo, la última esperaría su turno DESPUÉS de
   haber entrado, que es el error de sumar tiempos que ya nos costó una vuelta con
   las palabras del titular. */
/* 🔴 EL DISPARO VA RETRASADO, NO ANTICIPADO — y esto es la corrección de un error
   mío. Con `ojoAntes` medí que "no había vacío" y lo di por bueno; lo que en
   realidad estaba midiendo es que la animación TERMINABA ANTES DE VERSE. A
   velocidad humana (~960 px/s): la fila 1 asomaba ya al 63% de su barrido y a
   media pantalla estaba al 100%. Las cinco se armaban en la franja de abajo,
   fuera de donde uno mira. Por eso paco no veía nada.
   Con `-15%` por abajo, la fila arranca su barrido cuando ya está DENTRO del
   cuadro. Sí, aparece un instante sin color: ese instante es el "antes" de la
   animación, no un hueco. */
const ojoFilas = new IntersectionObserver(entradas => {
  entradas.forEach(e => {
    if (e.isIntersecting) e.target.classList.add('ver');
    else if (e.boundingClientRect.top > 0) e.target.classList.remove('ver');
    /* Solo se rearma si salió POR ABAJO. Si se rearmara al salir por arriba, al
       volver a subir la fila reaparecería en blanco encima del contenido que ya
       estabas leyendo. */
  });
}, { threshold: 0, rootMargin: '0px 0px -15% 0px' });

document.querySelectorAll('.elige .via').forEach((v, i) => {
  v.style.setProperty('--i', i);
  v.setAttribute('data-fila', '');
  ojoFilas.observe(v);
});

/* Se marcan solos los bloques que valen: el encabezado de cada sección y las
   piezas de las rejillas, escalonadas. Nada de reveal en TODO — eso es lo que
   hace baronfig, que es el más convencional de las quince referencias. */
document.querySelectorAll('.seccion').forEach(sec => {
  const enc = sec.querySelector('.etiqueta, .titular, .enc-partido, .enc-derecha, .enc-numero');
  // Un elemento oculto nunca intersecta: marcarlo lo deja con el estado de
  // reposo puesto y sin nadie que lo quite. (La píldora de ¿Te suena? va en
  // display:none a propósito desde la tanda 1.)
  if (enc && getComputedStyle(enc).display !== 'none') {
    enc.setAttribute('data-rev',''); vigila(enc);
  }
  // 🔴 `.sku` entró aquí cuando la tienda pasó a hojas troqueladas: el barrido
  // marcaba `.pieza`, y al renombrar las tarjetas los cinco SKUs se quedaron sin
  // revelado sin que nada fallara. Verificado midiendo `.sku[data-rev]`, que
  // daba 0. Renombrar una clase también rompe lo que la observa.
  // 🔴 `.tipo` salió de aquí junto con las píldoras 01–05 de §8. En su lugar
  // entran la foto del evento y los renglones del canal. Los renglones se
  // observan uno por uno igual que los demás: el escalonado tapa a los seis y
  // seis es justo el límite del `--i`.
  // 🔴 `.cf-uno` (las cinco fichas de arco de /sobre) entra AQUÍ y no estrena
  // mecanismo: el escalonado, la histéresis y el `--i` ya existen y funcionan.
  // Un segundo sistema de revelado para cinco tarjetas es exactamente el "dos
  // dueños para un gesto" que este archivo documenta dos veces más arriba.
  sec.querySelectorAll('.sku, .reel, .voz, .evento, .cf-uno, .videos li').forEach((el, i) => {
    /* 🔴 EL MURO DE LAS 52 QUEDA FUERA, Y NO POR CAPRICHO. Esa página coloca las
       reseñas con `columns`, y en un flujo por columnas el observador se pierde:
       recorriendo la página ENTERA sólo se revelaban 29 de 52 — las otras 23 se
       quedaban en `opacity:0` para siempre. Medido bajando de 2000 en 2000 px.
       En una página cuyo contenido ES las reseñas, un adorno que esconde el 44%
       de lo que se viene a leer no es un adorno: es un fallo. Se sale del
       mecanismo en vez de taparlo con un `!important`, que sólo escondería que
       aquí hay dos sistemas peleando. */
    if (el.closest('.muro-52')) return;
    el.setAttribute('data-rev',''); el.style.setProperty('--i', Math.min(i, 5));
    vigila(el);
  });
});

/* ═══ v3 · EL ACENTO NO LLEVA GESTO PROPIO ════════════════════════════════
   🔴 AQUÍ ME EQUIVOQUÉ DOS VECES Y LAS DOS SE VIERON EN PANTALLA.

   1 · Puse `clip-path` sobre el <span> del acento. Sobre un elemento EN LÍNEA
       que rompe en varias líneas, el recorte se aplica contra UN SOLO
       fragmento y todo lo demás desaparece: se comió "ELIGES", la O de
       "ELIGIENDO" y "MOVIMIENTO." Empeoró justo al pasar a Lemon Milk, porque
       la caja alta es más ancha y los acentos empezaron a partirse.

   2 · Al arreglarlo partiendo el acento en palabras, choqué con `.pal`, que YA
       EXISTE: es el sistema de revelado de `data-pals`, con su propio `<i>`
       interno y su presupuesto de escalonado. Mi split borraba esa estructura.
       Cuarta colisión de nombre de la sesión.

   La salida no es un tercer sistema: es NO tener uno. El acento cambia de
   familia, tamaño y color —que es lo que le faltaba— y su llegada la manda el
   revelado que la sección YA tiene. Dos dueños para el mismo gesto es el error
   que este archivo ya documentaba en §3, y volví a cometerlo.

   Lo que sí se hace: extender `data-pals` —el sistema PROBADO— a los titulares
   que no lo tenían. Así el gesto es uno solo en todo el sitio. */
/* Los dos huecos reales de movimiento, medidos: §manifiesto tenía 0 elementos
   revelados (solo el paralaje de su foto) y §library 1. No es que "falte
   movimiento en general" — es que a estas dos el barrido genérico no las
   alcanzaba porque su contenido no usa las clases que busca. */
document.querySelectorAll('.manifiesto p, .library .tarjeta, .library li')
  .forEach((el, i) => {
    el.setAttribute('data-rev',''); el.style.setProperty('--i', Math.min(i, 5));
    vigila(el);
  });

/* 🔴 §camino se quedaba SIN REVELADO y no era una decisión: `<section
   class="elige">` no lleva la clase `.seccion`, y el barrido de arriba recorre
   `.seccion`. Medido: `.elige .carta[data-rev]` daba 0. Las cinco tarjetas con
   foto —el bloque más grande de la portada— eran lo único que ya estaba
   montado cuando llegabas.
   Se observa CADA UNA, no el contenedor: el mosaico mide más de una pantalla y
   observando el contenedor las dos de abajo terminarían su entrada fuera de
   cuadro. Es la misma lección que ya costó tres intentos con las vías. */
document.querySelectorAll('.elige .carta').forEach((el, i) => {
  el.setAttribute('data-rev', ''); el.style.setProperty('--i', Math.min(i, 5));
  vigila(el);
});
